import React, { useState } from 'react';
import { Box, Card, Dialog, Grid, useMediaQuery, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import FreedomButton1 from '../FreedomButton1/FreedomButton1';
import FreedomTypographyText from '../FreedomTypographyText/FreedomTypographyText';
import FreedomFollowUpIcon from '../FreedomFollowUpIcon/FreedomFollowUpIcon';
import FreedomButton2 from '../FreedomButton2/FreedomButton2';
import { useNavigate } from 'react-router-dom';
import { WalletUrls } from '../../../url/Links';
import CloseIcon from '../CloseIcon/CloseIcon';
import { images, tableIcon } from '../../../url/SvgLinks';
import { useContext } from 'react';
import { ColorModeContext } from '../../../store';
import { getDynamicBorder, getStringProduct } from '../../../utils/utilityFunctions';
import useBreakPoints from '../../../CustomHooks/useBreakPoints';
const dangeralert = tableIcon.dangeralert;
const lightProductSelect = images.lightProductSelect;
const darkProductSelect = images.darkProductSelect;

export const useDialogStyle = makeStyles((theme) => ({
  root: {
    '& .MuiDialog-paperWidthSm': {
      borderRadius: '10px',
      minWidth: '300px',
      [theme.breakpoints.up('xll')]: {
        borderRadius: getStringProduct(1.25, '10px'),
        minWidth: getStringProduct(1.25, '300px')
      },
      [theme.breakpoints.up('xlll')]: {
        borderRadius: getStringProduct(1.66, '10px'),
        minWidth: getStringProduct(1.66, '300px')
      },
      [theme.breakpoints.up('xl4')]: {
        borderRadius: getStringProduct(2.46, '10px'),
        minWidth: getStringProduct(2.46, '300px')
      }
    }
  },
  root1: {
    //flexGrow: 1,
    '& .MuiDialog-paperWidthSm': {
      borderRadius: '10px',
      overflowY: 'auto',
      border: `2px solid ${theme.palette.border.popupBorder}`,
      maxWidth: (props) => props.root1MaxWidth || '481px',
      width: '100%',
      [theme.breakpoints.up('xll')]: {
        borderRadius: getStringProduct(1.25, '10px'),
        border: getDynamicBorder(1.25, `2px solid ${theme.palette.border.popupBorder}`),
        maxWidth: (props) => getStringProduct(1.25, props.root1MaxWidth || '481px')
      },
      [theme.breakpoints.up('xlll')]: {
        borderRadius: getStringProduct(1.66, '10px'),
        border: getDynamicBorder(1.66, `2px solid ${theme.palette.border.popupBorder}`),
        maxWidth: (props) => getStringProduct(1.66, props.root1MaxWidth || '481px')
      },
      [theme.breakpoints.up('xl4')]: {
        borderRadius: getStringProduct(2.46, '10px'),
        border: getDynamicBorder(2.46, `2px solid ${theme.palette.border.popupBorder}`),
        maxWidth: (props) => getStringProduct(2.46, props.root1MaxWidth || '481px')
      }
    },
    '& .css-198bggg-MuiPaper-root-MuiCard-root': {
      overflowY: 'auto'
    }
  },
  backDrop: {
    backdropFilter: 'blur(3px)',
    backgroundColor: 'rgba(0,0,30,0.4)'
  },
  dialogBox: {
    padding: '20px 0',
    overflowY: 'auto',
    background: theme.palette.primary.default,
    borderRadius: '10px',
    maxWidth: (props) => props.dialogBoxMaxWidth || '481px',
    width: '100%',
    [theme.breakpoints.up('xll')]: {
      padding: getStringProduct(1.25, '20px 0px'),
      borderRadius: getStringProduct(1.25, '10px'),
      maxWidth: (props) => getStringProduct(1.25, props.dialogBoxMaxWidth || '481px')
    },
    [theme.breakpoints.up('xlll')]: {
      padding: getStringProduct(1.66, '20px 0px'),
      borderRadius: getStringProduct(1.66, '10px'),
      maxWidth: (props) => getStringProduct(1.66, props.dialogBoxMaxWidth || '481px')
    },
    [theme.breakpoints.up('xl4')]: {
      padding: getStringProduct(2.46, '20px 0px'),
      borderRadius: getStringProduct(2.46, '10px'),
      maxWidth: (props) => getStringProduct(2.46, props.dialogBoxMaxWidth || '481px')
    }
  }
}));

const InsufficientBalancePopup = ({ dialogBoxMaxWidth, root1MaxWidth, openDialog, setOpenDialog, heading, children, Secondchildren, maxWidth, activeStep, setActiveStep, sendInvite, headingcolor, info, navigateUrl, okButtonText = 'OK' }) => {
  const theme = useTheme();
  const { getAdjustedValues } = useBreakPoints();
  const xl4 = useMediaQuery(theme.breakpoints.up('xl4'));
  const dialogStyle = useDialogStyle({ dialogBoxMaxWidth, root1MaxWidth });
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();

  const {
    colorMode: { mode }
  } = useContext(ColorModeContext);
  const InsufficientBalance = (
    <Box sx={{ overflowY: 'auto' }}>
      <Dialog
        open={openDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={dialogStyle.root1}
        BackdropProps={{
          classes: {
            root1: dialogStyle.backDrop
          }
        }}
        sx={{
          backdropFilter: 'blur(5px)',
          maxWidth: getAdjustedValues(maxWidth),
          overflow: 'none'
        }}
      >
        <Card className={dialogStyle.dialogBox}>
          <Box
            sx={{
              padding: '16px',
              [theme.breakpoints.down('sm')]: {
                padding: '8px'
              },
              [theme.breakpoints.up('xll')]: {
                padding: getStringProduct(1.25, '16px')
              },
              [theme.breakpoints.up('xlll')]: {
                padding: getStringProduct(1.66, '16px')
              },
              [theme.breakpoints.up('xl4')]: {
                padding: getStringProduct(2.46, '16px')
              }
            }}
          >
            <CloseIcon
              handleonclick={() => {
                setOpenDialog(false);
              }}
            />
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '6px',
                [theme.breakpoints.up('xll')]: {
                  gap: getStringProduct(1.25, '6px')
                },
                [theme.breakpoints.up('xlll')]: {
                  gap: getStringProduct(1.66, '6px')
                },
                [theme.breakpoints.up('xl4')]: {
                  gap: getStringProduct(2.46, '6px')
                }
              }}
            >
              <FreedomFollowUpIcon backgroundcolor={'transparent'} backgroundhovercolor={'none'} bordercolor={'none'} height="32px" width="32px" iconimg={info ? (mode == 'light' ? lightProductSelect : darkProductSelect) : dangeralert} />

              <FreedomTypographyText fontsize={isSmallScreen ? '16px' : '24px'} lineheight={isSmallScreen ? '24px' : '36px'} fontweight={700} color={headingcolor || theme.palette.text.primary}>
                {heading ? heading : 'Insufficient Balance'}{' '}
              </FreedomTypographyText>
            </Box>
            <FreedomTypographyText
              style={{
                letterSpacing: '1.3px',
                margin: isSmallScreen ? '18px 0px 24px 0px' : `${getAdjustedValues(10)}px ${getAdjustedValues(43)}px ${getAdjustedValues(16)}px ${getAdjustedValues(42)}px`
              }}
              textalign={'left'}
              fontsize={'12px'}
              lineheight={'18px'}
              fontweight={400}
              textcolor={theme.palette.text.primary}
            >
              {Secondchildren}
            </FreedomTypographyText>
            <FreedomTypographyText style={{ margin: isSmallScreen ? '18px 0px 24px 0px' : `${getAdjustedValues(10)}px ${getAdjustedValues(43)}px ${getAdjustedValues(16)}px ${getAdjustedValues(42)}px` }} fontsize={'12px'} lineheight={'18px'} fontweight={400} textcolor={theme.palette.text.primary}>
              {children ? children : 'Your balance is insufficient, please recharge your internal balance through wallet'}
            </FreedomTypographyText>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              {navigateUrl ? (
                <FreedomButton1
                  height={'48px'}
                  btnbackground={theme.palette.button.buttonbgcolor}
                  borderradius="10px"
                  width="150px"
                  onClick={() => {
                    navigate(navigateUrl);
                    setOpenDialog(false);
                  }}
                >
                  {okButtonText}
                </FreedomButton1>
              ) : activeStep >= 0 ? (
                <FreedomButton1
                  height={'48px'}
                  btnbackground={theme.palette.button.buttonbgcolor}
                  borderradius="10px"
                  width="150px"
                  onClick={() => {
                    if (activeStep == 0) {
                      setActiveStep((preActiveStep) => preActiveStep + 1);
                    } else {
                      sendInvite();
                    }
                    setOpenDialog(false);
                  }}
                >
                  {okButtonText}
                </FreedomButton1>
              ) : (
                <FreedomButton1
                  height={'48px'}
                  btnbackground={theme.palette.button.buttonbgcolor}
                  borderradius="10px"
                  width="150px"
                  onClick={() => {
                    navigate(WalletUrls.cashDeposit);
                    setOpenDialog(false);
                  }}
                >
                  Go to Wallet
                </FreedomButton1>
              )}
            </Box>
          </Box>
        </Card>
      </Dialog>
    </Box>
  );

  return <div>{InsufficientBalance}</div>;
};

export default InsufficientBalancePopup;
